import { createPrefixedConstants } from 'app/common/CommonUtils';

export default createPrefixedConstants(
  'viewport',
  `
    OPEN_NOTIFICATIONS_DROPDOWN
    CLOSE_NOTIFICATIONS_DROPDOWN
  `
);
